import script from "./color-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./color-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./color-setting-ly.vue?vue&type=style&index=0&id=7260e3fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7260e3fe"]])

export default __exports__